
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/reviews",
      function () {
        return require("private-next-pages/dining/reviews.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/reviews"])
      });
    }
  